import { IconButton } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useMapContext } from '@schamburg-web/components';

const CardCloseButton: React.FC = () => {
  const { setSelectedMapIcon } = useMapContext();
  const handleClose = () => {
    setSelectedMapIcon(null, null);
  };
  return (
    <IconButton
      size="small"
      onClick={handleClose}
      aria-label="close map popup"
      sx={{ mt: 0, mr: 1 }}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );
};

export default CardCloseButton;
